import { colord } from 'colord';

const PaletteConfig = {
  LIGHTEN_FACTORS: [0.4, 0.35, 0.3, 0.25, 0.2], // p0-p40 (lighter)
  DARKEN_FACTORS: [0.05, 0.1, 0.15, 0.2, 0.25, 0.3, 0.35, 0.4, 0.45, 0.5], // p60-p150 (darker)
  STEP: 10,
};

/**
 * Generates a palette for a given base color by lightening and darkening it.
 */
export function generatePalette(
  base: string,
  config = PaletteConfig
): Record<string, string> {
  const c = colord(base);
  const palette: Record<string, string> = {};

  // Generate lighter shades: p0, p10, p20, p30, p40
  config.LIGHTEN_FACTORS.forEach((factor, i) => {
    const key = `p${i * config.STEP}`;
    palette[key] = c.lighten(factor).toHex();
  });

  // Base color at p50
  palette['p50'] = base;

  // Generate darker shades: p60, p70, p80, p90, p100
  config.DARKEN_FACTORS.forEach((factor, i) => {
    const key = `p${(i + 6) * config.STEP}`; // Start at p60
    palette[key] = c.darken(factor).toHex();
  });

  return palette;
}
